export default __webpack_public_path__ + "static/media/thailand.ee6453cf.png";